import { Box, BoxProps, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "../hooks";

interface SearchBarProps {
  onChange?: any;
  placeHolder: string;
  focused?: boolean;
  onFocus?: () => void;
}

// One field, drawn as the portal's own outlined input. The square coloured
// button it replaces was the last control on the front door still styled like
// the old design, and read as separate from the box beside it.
const SearchBar = ({
  placeHolder,
  focused = false,
  onFocus = () => null,
  onChange = () => null,
  ...rest
}: SearchBarProps & BoxProps) => {
  const { theme } = useTheme();

  return (
    <Box
      {...rest}
      sx={{
        display: "flex",
        alignItems: "center",
        bgcolor: "background.paper",
        border: 1,
        borderColor: "divider",
        borderRadius: 3,
        px: 1.75,
        height: 50,
        transition: "border-color 120ms ease",
        "&:focus-within": { borderColor: theme.color_primary },
      }}
    >
      <SearchIcon aria-hidden sx={{ color: "text.secondary", mr: 1 }} />
      <TextField
        type="search"
        onChange={onChange}
        variant="standard"
        placeholder={placeHolder}
        size="medium"
        fullWidth
        autoFocus={focused}
        onFocus={onFocus}
        inputProps={{ "aria-label": placeHolder }}
        InputProps={{ disableUnderline: true }}
      />
    </Box>
  );
};

export default SearchBar;
